import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-profile-image.scss';

@customElement('vm-profile-image')
export class VmProfileImage extends LitElement {
    static styles = Styles;

    @property({ type: String }) userName = 'Vumedi User';
    @property({ type: String }) imageSrc = '';
    @property({ type: String }) imageAlt = '';
    @property({ type: String }) link = '';
    @property({ type: String, reflect: true }) fit = '';

    connectedCallback() {
        super.connectedCallback();
        if (!this.dataset.colorIndex) {
            const name = this.userName || 'Vumedi User';
            this.dataset.colorIndex = String((name.charCodeAt(0) % 5) + 1);
        }
    }

    render() {
        const name = this.userName || 'Vumedi User';

        if (this.imageSrc) {
            return html`
                <figure class="vm-profile-image" part="figure">
                    <img src="${this.imageSrc}" alt="${this.imageAlt || `${name} profile image`}" part="image" />
                    ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
                </figure>
            `;
        }

        return html`
            <span class="vm-profile-image vm-profile-image--initials" part="initials">
                ${name.slice(0, 1).toUpperCase()} ${this.link ? html`<a href="${this.link}" part="link"></a>` : ''}
            </span>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-profile-image': VmProfileImage;
    }
}
